import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTimeMatrix } from '../../../../Hooks/Features/Pocker/useTimeMatrix'
import CommonGrid from '../../../../components/CommonCompo/CommonGrid/CommonGrid';
import { useCommon } from '../../../../Hooks/Common/useCommon';
import { Tooltip } from 'primereact/tooltip';
import { SkeletonContainer } from '../../../../components/Loader/Loader';

const TimeMatrix = () => {

  const { getValuePermission } = useCommon();
  const { getMatrixData, options, columns, rowData, editData, setEditData, saveMatrixData, tooltip, loader } = useTimeMatrix();

  return (!getValuePermission("time_matrix_tab") &&
    <div>
      <div className='sk-header-row d-flex gap-2 align-items-center justify-content-end'>
        {editData?.isEditing ?
          <div className='d-flex gap-2'>
            <div>
              <button className='sk-btn sk-btn-primary' title='Cancel' onClick={() => setEditData((prev) => ({ ...prev, isEditing: false, updated: {}, previous: {} }))} ><FontAwesomeIcon icon="fa-solid fa-close" /></button>
            </div>
            <div>
              {loader?.btn ?
                <button className='sk-btn sk-btn-primary bg-black text-white' title='Save'>
                  <div className="spinner-border" role="status" style={{ width: "15px", height: "15px" }}>
                    <span className="sr-only"></span>
                  </div>
                </button> :
                <button className='sk-btn sk-btn-primary bg-black text-white' title='Save' onClick={() => saveMatrixData()}><FontAwesomeIcon icon="fa-solid fa-floppy-disk" /></button>
              }
            </div>
          </div>
          : <div>
            <button className='sk-btn sk-btn-primary' title='Edit' onClick={() => setEditData((prev) => ({ ...prev, isEditing: true, updated: {}, previous: {} }))}><FontAwesomeIcon icon="fa-solid fa-pen" /></button>
          </div>
        }
        <div>
          <button className='sk-btn sk-btn-primary' title='Refresh' onClick={() => getMatrixData()}><FontAwesomeIcon icon="fa-solid fa-arrows-rotate" /></button>
        </div>
      </div>
      <div className='d-flex justify-content-center time-matrix-grid mt-4'>
        {loader?.matrix ?
          <div style={{ height: "350px", width: "1120px" }}><SkeletonContainer /></div> :
          <CommonGrid columns={columns} data={[{ id: "all", title: "", children: rowData?.data }]} headerHeight={40} rowHeight={"auto"} />
        }
      </div>
      <Tooltip target=".time-matrix-tooltip" position='top' escape="false" className='project-glance-tooltip'>
        {!editData?.isEditing && <div style={{ fontSize: "0.8rem" }} className='fw-semibold p-2'>
          <div className='text-secondary pb-2'>AUDIT SCOPE</div>
          <div className='fw-bold' style={{ fontSize: "0.9rem" }}>{tooltip?.longitivity} × {tooltip?.complexity}</div>
        </div>}
      </Tooltip>
    </div>
  )
}

export default TimeMatrix